<template>
  <div class="modal-card" style="width: auto">
    <header class="modal-card-head">
      <p class="modal-card-title">Create a new ban</p>
      <button
        type="button"
        class="delete"
        @click="$parent.close()"/>
    </header>
    <section class="modal-card-body">
      <b-notification @close="resetErrors" :active="newBanErrors != null" type="is-danger" has-icon aria-close-label="Close notification" role="alert">
        {{ newBanErrors }}
      </b-notification>

      <b-field grouped >
        <b-field label="Banned item or user">
          <b-input disabled value ="/craft/63"></b-input>
        </b-field>

        <b-field label="Period">
          <b-select  placeholder="Choose" icon="clock">
                          <option value="1week">One week</option>
                          <option value="1month">One month</option>
                          <option value="forever">Forever</option>
          </b-select>
        </b-field>

        <b-field label="Reason">
            <b-autocomplete
                open-on-focus
                v-model="ban.reason"
                :data="filteredDataArray"
                placeholder="e.g. Harassment"
                @select="option => selected = option">

            </b-autocomplete>
        </b-field>
      </b-field>

      <b-field label="Internal note (optional)">
        <b-input maxlength="200" type="textarea" ></b-input>
      </b-field>
    </section>

    <footer class="modal-card-foot">
      <span class="card-footer-item">
        <b-button @click="confirmCustomBan" type="is-warning" icon-pack="mdi" icon-left="cancel">
            Ban item or user
        </b-button>
      </span>

      <span class="card-footer-item">
        <b-button @click="$parent.close()">
          Close
        </b-button>
      </span>
    </footer>
  </div>
</template>

<script>
import { notificationMixin } from '@/mixins/notificationMixin.js'
export default {

  mixins: [ notificationMixin ],
  data () {
    return {
      ban: {
        user_banned: null,
        user_banning: null,
        internal_note: null,
        period: null,
        reason: ''
      },
      reason_data: [
        'Sexualized content',
        'Aggressive content',
        'Discrimination'
      ],
      newBanErrors: null
    }
  },
  computed: {
    filteredDataArray () {
      return this.reason_data.filter((option) => {
        return option
          .toString()
          .toLowerCase()
          .indexOf(this.ban.reason.toLowerCase()) >= 0
      })
    }
  },
  methods: {

    resetErrors () {
      this.newBanErrors = null
    },
    confirmCustomBan () {
      this.$buefy.dialog.confirm({
        title: 'Ban user',
        message: 'Are you sure you want to ban <b>XXX</b> for <b>XXX weeks</b>?',
        confirmText: 'Ban User',
        type: 'is-warning',
        hasIcon: true,
        onConfirm: () => this.$buefy.toast.open('User XXX has been banned for XX month')
      })
    }
  }
}
</script>
